import React, { Component } from "react";
import {
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Progress,
  Collapse,
  CardBody,
  UncontrolledTooltip,
  Button,
} from "reactstrap";
import { post } from "axios";
import { withRouter } from "react-router";
import "react-toggle/style.css";
import Toggle from "react-toggle";
import moment from "moment";
import JSMpeg from "jsmpeg-player";
import Proptypes from "prop-types";
import "rc-slider/assets/index.css";
import { connect } from "react-redux";
import Slider, { createSliderWithTooltip } from "rc-slider";
import { NotificationManager } from "react-notifications";
import stopReload from "../../constants/Constants";
import {
  destroyKasmShareId,
  createKasmShareId,
} from "../../actions/actionDashboard";
import ChatComponent from "../Chat/ChatComponent";
import soundEnabled from "../../../assets/images/soundEnabled.png";
import soundDisabled from "../../../assets/images/soundDisabled.png";
import leftArrow from "../../../assets/images/leftArrow.png";
import logout from "../../../assets/images/logout.png";
import apps from "../../../assets/images/apps.png";
import cross from "../../../assets/images/cross.png";
import audio from "../../audio";


var player;
var keepAlive;
var renderNav;

const IS_TOUCH_DEVICE = (
  ("ontouchstart" in window) ||
  (navigator.maxTouchPoints > 0) ||
  (navigator.msMaxTouchPoints > 0)
);

class ViewPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      showNav: false,
      audio: true,
      collapse: false,
      currentIndex: null,
      shareLink: null,
      message: null,
      disableIndex: [],
      modalAdvanced: false,
      logoutAll: false,
    };

    this.showNav = this.showNav.bind(this);
    this.hideNav = this.hideNav.bind(this);
    this.toggleNav = this.toggleNav.bind(this);
    this.confirmLogout = this.confirmLogout.bind(this);
    this.cancelLogout = this.cancelLogout.bind(this);
    this.showLogout = this.showLogout.bind(this);
    this.toggleLogout = this.toggleLogout.bind(this);
    this.toggle = this.toggle.bind(this);
    this.showMessage = this.showMessage.bind(this);
    this.handleAudioChange = this.handleAudioChange.bind(this);
    this.receiveMessage = this.receiveMessage.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.copyToClipboard = this.copyToClipboard.bind(this);
    this.hideNavDelay = this.hideNavDelay.bind(this);
    this.handleLeave = this.handleLeave.bind(this);
    this.updateLogoutAll = this.updateLogoutAll.bind(this);
  }

  handleLeave(location) {
    console.trace("Navigating browser to " + location);
    window.removeEventListener("beforeunload", stopReload, true);
    this.props.history.push(location);
  }

  handleAudioChange(enable) {
    const { statusKasms } = this.props;

    if (!statusKasms.port_map.audio) {
      return;
    }

    if (enable) {
      audio.enable();
    } else {
      audio.disable();
    }

    this.setState({ audio: enable });
  }

  showLogout() {
    this.setState({
      modal: true,
      showNav: false,
    });
  }

  confirmLogout() {
    this.toggleLogout();
    window.removeEventListener("beforeunload", stopReload, true);
    let logout_data = { logout_all: this.state.logoutAll };
    this.props.logout(logout_data);
  }

  receiveMessage(event) {
    if (event.data && event.data.action == "clipboardrx") {
      if (this.state.clipboardDown) {
        this.setState({ clipboardText: event.data.value });
      }
    } else if (
      event.data &&
      event.data.action == "disconnectrx" &&
      !this.state.destroyClicked
    ) {
      this.props.handleDisconnect();
    } else if (event.data.action == "togglenav") this.toggleNav();
    else if (event.data.action == "idle_session_timeout") {
      window.disableAPIActiveState = 1;
      setTimeout(function () {
        window.disableAPIActiveState = 0;
      }, 5000);
      this.handleLeave("/");
    }
  }

  componentDidMount() {
    this.props.statusKasms.share_id &&
      this.setState({ shareLink: this.props.statusKasms.share_id });

    if (this.props.disconnect) {
      this.setState({ showNav: false });
    }

    if (window.addEventListener) {
      window.addEventListener("message", this.receiveMessage, false);
    } else if (window.attachEvent) {
      window.attachEvent("message", this.receiveMessage);
    }
    this.setState({ modal: false });

    if (this.props.statusKasms && this.props.statusKasms.client_settings) {
      this.setState({
        audio: this.props.statusKasms.client_settings.kasm_audio_default_on,
      });
    }

    // Add audio for when the domain already allows audio and add event listener to re establish audio on first
    // click to resolve sync problems
    const { statusKasms } = this.props;

    if (
      statusKasms.client_settings &&
      statusKasms.client_settings.allow_kasm_audio &&
      statusKasms.client_settings.kasm_audio_default_on &&
      statusKasms.port_map.audio
    ) {
      audio.initialize({
        canvasEl: document.querySelector("video-canvas"),
        url: `wss://${statusKasms.hostname}:${statusKasms.port_map.audio.port}/${statusKasms.port_map.audio.path}/`,
        isAllowed: statusKasms.client_settings.kasm_audio_default_on
      });

      // Auto-play on desktop or on user UI action on mobile
      if (statusKasms.client_settings.kasm_audio_default_on) {
        if (!IS_TOUCH_DEVICE) {
          audio.enable();
        } else {
          document.addEventListener("touchstart", () => audio.enable(), { once: true });
        }
      }
    }

    if (window.addEventListener) {
      window.addEventListener("message", this.receiveMessage, false);
    } else if (window.attachEvent) {
      window.attachEvent("message", this.receiveMessage);
    }

    window.addEventListener("blur", this.hideNavDelay);
  }

  hideNavDelay() {
    renderNav = setTimeout(() => {
      if (document.activeElement instanceof HTMLIFrameElement) {
        this.hideNav();
      }
    }, 10);
  }

  componentWillUnmount() {
    audio.disable();
    clearInterval(keepAlive);
    clearTimeout(renderNav);
    window.removeEventListener("blur", this.hideNavDelay);
    window.removeEventListener("message", this.receiveMessage, false);
  }

  cancelLogout() {
    this.toggleLogout();
    this.handleLeave("/");
  }

  showNav() {
    this.setState({ showNav: true });
  }

  hideNav() {
    this.setState({ showNav: false });
  }

  toggleNav() {
    this.setState({ showNav: !this.state.showNav });
  }

  toggleLogout() {
    this.setState({ modal: !this.state.modal });
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  handleClose(e) {
    this.handleLeave("/");
  }

  showMessage(i) {
    const { fileStatusArr } = this.state;
    let element = "";

    element = fileStatusArr.find(function (element) {
      return element.index === i;
    });

    if (element) {
      if (element && element["success-status"]) {
        return (
          <span className="text-success blk_inline mt-7">
            {" "}
            {element["success-status"]}{" "}
          </span>
        );
      } else if (element && element["failure-status"]) {
        return (
          <span className="text-danger blk_inline mt-7">
            {" "}
            {element["failure-status"]}{" "}
          </span>
        );
      }
    }
    return " ";
  }

  copyToClipboard(str) {
    const el = document.createElement("textarea");
    el.value = str;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
  }

  openWindow(url) {
    window.open(
      url,
      "_blank",
      "resizable=yes,top=0,left=0,width=800,height=640"
    );
  }

  updateLogoutAll() {
    this.setState({ logoutAll: !this.state.logoutAll });
  }

  render() {
    const { statusKasms } = this.props;
    const userInfo = JSON.parse(window.localStorage.user_info);
    const navOverride = this.props.hideViewPanel ? { display: "None" } : {};

    // Send an event to the parent document (kasm app) to toggle the control panel when ctl is double clicked
    var delta = 500;
    var lastKeypressTime = 0;
    if (this.props.toggle_control_panel === true) {
      document.addEventListener(
        "keyup",
        (event) => {
          const keyName = event.key;
          // CTRL and the various implementations of the mac command key
          if ([17, 224, 91, 93].indexOf(event.keyCode) > -1) {
            let thisKeypressTime = new Date();
            if (thisKeypressTime - lastKeypressTime <= delta) {
              this.toggleNav();
              thisKeypressTime = 0;
            }
            lastKeypressTime = thisKeypressTime;
          }
        },
        true
      );
    }
    return (
      <div>
        <canvas id="video-canvas" />
        <i
          id="nav_toggle"
          className="fa fa-ellipsis-v toggle_icon"
          onClick={this.showNav}
          aria-hidden="true"
          style={navOverride}
        />
        {statusKasms && (
          <div
            id="mySidenav"
            className={
              this.state.showNav && !this.props.hideViewPanel
                ? "sidenavnew show_nav"
                : "sidenavnew hide_nav"
            }
          >
            <div className="sidebar-icons-list">
              <button
                className="sidebar-icons "
                onClick={() => {
                  this.setState({
                    showNav: !this.state.showNav,
                  });
                }}
              >
                <img src={leftArrow} alt="leftArrow" />
                <div className="sidebar-icons-hover">
                  <p>Hide Toolbar</p>
                </div>
              </button>

              {statusKasms.client_settings.allow_kasm_audio == true && statusKasms.port_map.audio && (
              <button
                className={
                  "sidebar-icons square " +
                  (this.state.audio ? "soundEnabled" : "soundDisabled")
                }
                onClick={() => {
                  this.handleAudioChange(!this.state.audio);
                }}
              >
                <img
                  src={this.state.audio ? soundEnabled : soundDisabled}
                  alt="soundEnabled"
                />
                <div className="sidebar-icons-hover">
                  <p>{this.state.audio ? "Sound Enabled" : "Sound Disabled"}</p>
                </div>
              </button>
              )}
              <button
                className="sidebar-icons"
                onClick={() => this.handleLeave("/userdashboard")}
              >
                <img src={apps} alt="apps" />
                <div className="sidebar-icons-hover">
                  <p>All Workspaces</p>
                </div>
              </button>
              <button
                className="sidebar-icons"
                onClick={() => this.showLogout()}
              >
                <img src={logout} alt="logout" />
                <div className="sidebar-icons-hover">
                  <p>Log Out</p>
                </div>
              </button>
            </div>
          </div>
        )}
        <Modal
          zIndex={999999}
          isOpen={this.state.modal}
          toggle={this.toggleLogout}
          className="launch-modal"
        >
          <ModalBody style={{maxHeight: "245px"}}>
            <div className="modal-inner">
              <div className="opera-box">
                <div className="opera-box-img">
                  {this.state.deleteKasmImage != "" ? (
                    <img
                      src={this.props.statusKasms.image.image_src}
                    />
                  ) : (
                    <i className="fa fa-laptop bg-info p-3 font-2xl mr-3 float-left" />
                  )}
                </div>
                <div className="opera-box-detail">
                  <div className="modal-item">
                    <h4>{this.props.statusKasms.image.friendly_name}</h4>
                    <button className="close-icon" onClick={this.toggleLogout}>
                      <img src={cross} alt="close" />
                    </button>
                  </div>
                  <p className="opera-Productivity">
                    <span>Are you sure you want to logout?</span>
                  </p>
                </div>
              </div>
              <p className="opera-Productivity">
                <span><input type="checkbox" value={this.state.logoutAll} onChange={this.updateLogoutAll}/> &nbsp; &nbsp;Sign out of all devices.</span>
              </p>
              <div>
                <Button 
                  onClick={this.confirmLogout}
                  color="danger"
                  style={{ width: "100%", padding: "20px"}}
                >
                  Logout
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

ViewPanel.propTypes = {
  logout: Proptypes.func.isRequired,
  statusKasms: Proptypes.object,
  history: Proptypes.object,
  kasmId: Proptypes.func,
  videoQuality: Proptypes.number,
  setVideoQuality: Proptypes.func,
  handleDisconnect: Proptypes.func,
  hideViewPanel: Proptypes.bool,
};

ViewPanel = withRouter(ViewPanel); // eslint-disable-line

export default connect(
  (state) => ({
    share_id: state.dashboard.share_id || null,
    destroyShareLoading: state.dashboard.destroyShareLoading || null,
    destroyShareError: state.dashboard.destroyShareError || null,
    createShareLoading: state.dashboard.createShareLoading || null,
    createShareError: state.dashboard.createShareError || null,
  }),
  (dispatch) => ({
    createKasmShareId: (data) => dispatch(createKasmShareId(data)),
    destroyKasmShareId: (data) => dispatch(destroyKasmShareId(data)),
  })
)(ViewPanel);



// WEBPACK FOOTER //
// ./src/components/ViewPanel/ViewPanel.js